module.exports = __webpack_public_path__ + "img/alphaIcon.ad0202d9.svg";